import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';

import { DirectTreasuryDetailsModalComponentsProps } from '../..';

export const DirectTreasuryDetailsHeader = ({
  onClose,
  item,
}: DirectTreasuryDetailsModalComponentsProps) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <VStack>
        <HStack justifyContent="space-between">
          <UI.Text color="neutral.dark">Detalhes do produto</UI.Text>
          <UI.IconButton
            testId={'icon-close'}
            icon="Close"
            iconSize="xxxxxs"
            borderWidth={{ base: 0, lg: '1px' }}
            variant="rounded"
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            borderColor={Color['brand.primary.principal']}
            onPress={onClose}
          />
        </HStack>
        <UI.Heading testId="direct-treasury-title" size="h4">
          {item.titleName}
        </UI.Heading>
      </VStack>
      <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
    </VStack>
  );
};
